module.exports = __webpack_public_path__ + "static/media/Designer-Yone-Yone.a507c424.png";